<template>
    <div class="donate__form__dropdown donate__form--w-100 text-children--tertiary border-children--tertiary">
        <multi-select
                @input="checkAmountValue"
                v-model="value"
                deselect-label="Huidige keuze"
                track-by="name"
                label="name"
                :placeholder="placeholder"
                :options="options"
                :searchable="false"
                :allow-empty="false">
            <template slot="singleLabel" slot-scope="props">
                <span class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                </span>
            </template>
        </multi-select>
    </div>
</template>
<script>
    import multiSelect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    export default {
        components: {
            'multi-select': multiSelect
        },
        props: {
          'selected': {required: false, default: null},
          'placeholder': {required: true},
          'options': {required: true}
        },
        data () {
            return {
                value: this.setValueFromSelected()
            }
        },
        methods: {
            checkAmountValue: function(){
                this.$emit('dropdownChange', this.value);
            },
            setValueFromSelected: function(){
                return this.options.find(obj => {
                    return obj.value === this.selected;
                });
            },
            setValueOnLoad: function(amount){
                this.value = this.options.find(obj => {
                    return obj.value === amount;
                });
            }
        }
    }
</script>
<style lang="scss">
    /*your styles*/
    .multiselect__tags {
        width:100%;
        background: none;
        border: 2px solid #6eb52e;
        border-radius: 30px;
        box-sizing: border-box;
        padding:16px 20px 16px;
        cursor: pointer;
        user-select: none;
        text-align: left;
    }
    .multiselect:not(.multiselect--above) .multiselect__tags {
        transition: border-bottom-left-radius 0.1s, border-bottom-right-radius 0.1s;
    }
    .multiselect.multiselect--above .multiselect__tags {
        transition: border-top-left-radius 0.1s, border-top-right-radius 0.1s;
    }
    .multiselect.multiselect--active.multiselect--above .multiselect__tags {
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }
    .multiselect--above.multiselect--active {
        padding-bottom: 0;
    }
    .multiselect--active:not(.multiselect--above) .multiselect__tags {
        border-bottom: 0;
    }
    .multiselect--active.multiselect--above .multiselect__tags {
        border-top: 2px solid #FFFFFF;
    }
    .multiselect__placeholder {
        color: #6eb52e;
        font: 700 20px "pt-sans-pro", sans-serif;
        letter-spacing: 1px;
        margin-bottom: 0;
        padding-top: 0;
    }
    .multiselect__select {
        position: absolute;
        text-align: center;
        right: 22px;
        top: 22px;
        width: 22px;
        height: 22px;
        font-size: 27px;
        font-family: 'Font Awesome 5 Pro', sans-serif;
        /*background: url("../../../images/down_arrow.png") no-repeat center;*/
        background-size: 15px;
        transition: transform 0.2s;
        padding: 0;
        line-height: 22px;
        text-align: center;
    }

    .multiselect__select:before {
        display: none;
    }
    .multiselect__select:after {
        position: absolute;
        font-family: "Font Awesome 5 Pro";
        top: 0;
        left: 0;
        content: "\F107";
        border: 0;
        width: 100%;
        height: 100%;
        color: #6eb52e;
    }
    .multiselect__single {
        padding-left: 5px;
        margin-bottom: 8px;
    }
    .multiselect__single, .multiselect__placeholder {
        background: none;
        color: #6eb52e;
        font: 700 20px "pt-sans-pro", sans-serif;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        text-align: left;
        letter-spacing: 1px;
        padding-left: 0;
        margin-bottom: 0;
    }
    .multiselect--active .multiselect__placeholder,
    .multiselect--active .multiselect__single {
        display: block;
        opacity: 0.4;
    }
    .multiselect__content-wrapper {
        background-color: #FFF;
        z-index: 99;
        height: auto;
        border-left: 0;
        border-right: 0;
        border-bottom: 0;
        border-bottom-left-radius: 30px;
        border-bottom-right-radius: 30px;
        padding: 0 20px;
        max-height: 0 !important;
        visibility: hidden;
        display:block !important;
    }
    .multiselect:not(.multiselect--above) .multiselect__content-wrapper {
        transition: max-height 0.2s 0.1s, border-right 0.2s 0.05s, border-top 0.2s 0.05s, border-left 0.2s 0.05s;
    }
    .multiselect.multiselect--above .multiselect__content-wrapper {
        transition: max-height 0.2s 0.1s, border-right 0.2s 0.05s, border-bottom 0.2s 0.05s, border-left 0.2s 0.05s;
    }
    .multiselect--active  .multiselect__content-wrapper {
        max-height: 320px !important;
        visibility: visible;
        border-left: 2px solid #6eb52e;
        border-right: 2px solid #6eb52e;
        display:block !important;
    }
    .multiselect--active:not(.multiselect--above) .multiselect__content-wrapper {
        border-bottom: 2px solid #6eb52e;
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-bottom-left-radius: 30px !important;
        border-bottom-right-radius: 30px !important;
        transition: max-height 0.2s 0.1s, border-right 0.2s 0.05s, border-bottom 0.2s 0.05s, border-left 0.2s 0.05s;
    }
    .multiselect--active.multiselect--above .multiselect__content-wrapper {
        border-top: 2px solid #6eb52e;
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
        border-top-left-radius: 30px !important;
        border-top-right-radius: 30px !important;
        transition: max-height 0.2s 0.1s, border-right 0.2s 0.05s, border-top 0.2s 0.05s, border-left 0.2s 0.05s;
        margin-bottom:-2px;
    }
    .multiselect__option {
        color: #6eb52e;
        padding:16px 0 16px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        font: 500 20px "pt-sans-pro", sans-serif;
        text-align: left;
        letter-spacing: 1px;
    }
    .multiselect__option--selected {
        background: none;
        font-weight:bold;
    }
    .multiselect__option--highlight, .multiselect__option--selected.multiselect__option--highlight {
        background:none;
        color: #6eb52e;
        font-weight: bold;
    }
    .multiselect__element {
        border-top: 1px solid #d0e6ba;
    }
    .multiselect--active:not(.multiselect--above) .multiselect__element:first-child {
        border-top: 1px solid #6eb52e;
    }
    .multiselect--active.multiselect--above .multiselect__element:first-child {
        border-top: 0;
    }
    .multiselect--active.multiselect--above .multiselect__element:last-child {
        border-bottom: 1px solid #6eb52e;
    }
    .multiselect__element span:after {
        display: none;
    }
    @media screen and (min-width: 768px) {
        .multiselect--active {
            padding-bottom:2px;
        }
        .multiselect__tags {
            background: none;
            padding: 12px 20px;
            border-radius: 24px;
        }
        .multiselect__single, .multiselect__placeholder {
            font-size: 20px;
        }
        .multiselect__select {
            top: 0;
            right: 0;
            background-size: 20px;
            width: 54px;
            height: 54px;
            line-height: 54px;
        }
        .multiselect__content-wrapper {
            padding: 0 20px;
            border-bottom-left-radius: 30px;
            border-bottom-right-radius: 30px;
        }
        .multiselect__option {
            font-size: 19px;
            padding: 12px 0;
        }
    }
</style>